import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const base =
  "block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-slate-900 " +
  "placeholder:text-slate-400 focus:border-brand-600 focus:outline-none focus:ring-2 " +
  "focus:ring-brand-600 disabled:bg-slate-100 disabled:text-slate-500";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      // 44px tall so it is comfortable on a phone (E-15).
      className={cn(base, "h-11", invalid && "border-blocking ring-1 ring-blocking", className)}
      aria-invalid={invalid || undefined}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea ref={ref} rows={3} className={cn(base, className)} {...props} />
));
Textarea.displayName = "Textarea";
